import type { ComponentType, ReactNode, SVGProps } from 'react'

import styles from './AudioStats.module.css'

export type TAudioStatItem = {
    id: string
    label: string
    value: string
    Icon?: ComponentType<SVGProps<SVGSVGElement>>
    onClick?: () => void
}

type TAudioStatsProps = {
    items: TAudioStatItem[]
    upsellSlot?: ReactNode
}

type TStatItemProps = Omit<TAudioStatItem, 'id'>

const StatItem = ({ label, value, Icon, onClick }: TStatItemProps) => {
    const content = (
        <>
            <span className={styles.top}>
                <span className={styles.value}>{value}</span>
                {Icon ? (
                    <span className={styles.icon}>
                        <Icon />
                    </span>
                ) : null}
            </span>
            <span className={styles.label}>{label}</span>
        </>
    )

    if (onClick) {
        return (
            <button type="button" className={styles.item} onClick={onClick}>
                {content}
            </button>
        )
    }

    return <div className={styles.item}>{content}</div>
}

export const AudioStats = ({ items, upsellSlot }: TAudioStatsProps) => (
    <div className={styles.grid}>
        {items.map(item => (
            <StatItem key={item.id} {...item} />
        ))}
        {upsellSlot}
    </div>
)
